import { VideoPlayer } from '../../components/VideoPlayer/VideoPlayer';
import './style.scss';
import React from 'react';

export const TestPlayer = () => {
  return (
    <div className='test-container'>
      <div className='some-container'>
        <VideoPlayer
          isEditMode={true}
          config={{
            elements: [
              {
                type: 'image',
                id: 'f8a540d2-e37c-45a6-9c2d-ac73240f9626',
                at: 3,
                position: { x: 0.15875, y: 0.30444444444444446 },
                rotate: 0,
                animate: { in: 'bounceIn', out: 'fadeOut' },
                duration: 3,
                size: { height: 0.3, width: 0.5 },
                url: 'https://media2.giphy.com/media/J5dm29T4xgwyEnUYYc/giphy.gif?cid=16be1fca8bcf5561b5cf0fb52654f167474b3ca89bdc8a33&rid=giphy.gif',
                name: 'New Layer 1',
              },
              {
                type: 'image',
                id: 'dce9d012-febb-40ee-afae-2d65fa1ffb0f',
                at: 5,
                position: { x: 0.73, y: 0.02 },
                rotate: 0,
                animate: { in: 'bounceIn', out: 'fadeOut' },
                duration: 2,
                size: { height: 0.12, width: 0.13 },
                url: 'https://media1.giphy.com/media/U843CaLByvsG2axdQO/giphy.gif?cid=16be1fcaf9088045aade732dde147dbf358bb68add5d03df&rid=giphy.gif',
              },
            ],
          }}
          src={'https://storage.googleapis.com/assetlib/ce66007f-f215-4f10-a8f4-ab9201601a02.mp4'}
        />
      </div>
      <br />
      <br />
      {/* <div className='some-container2'>
        <VideoPlayer
          isEditMode={true}
          config={{
            elements: [
              {
                type: 'image',
                id: 'f8a540d2-e37c-45a6-9c2d-ac73240f9626',
                at: 2.114434,
                position: { x: 0.15875, y: 0.30444444444444446 },
                rotate: 0,
                animate: { in: 'bounceIn', out: 'fadeOut' },
                duration: 2,
                size: { height: 0.3, width: 0.5 },
                url: 'https://media2.giphy.com/media/J5dm29T4xgwyEnUYYc/giphy.gif?cid=16be1fca8bcf5561b5cf0fb52654f167474b3ca89bdc8a33&rid=giphy.gif',
                name: 'New Layer 1',
              },
              {
                type: 'image',
                id: 'dce9d012-febb-40ee-afae-2d65fa1ffb0f',
                at: 7.767371,
                position: { x: 0.73, y: 0.02 },
                rotate: 0,
                animate: { in: 'bounceIn', out: 'fadeOut' },
                duration: null,
                size: { height: 0.12, width: 0.13 },
                url: 'https://media1.giphy.com/media/U843CaLByvsG2axdQO/giphy.gif?cid=16be1fcaf9088045aade732dde147dbf358bb68add5d03df&rid=giphy.gif',
              },
            ],
          }}
          src={'https://storage.googleapis.com/assetlib/ce66007f-f215-4f10-a8f4-ab9201601a02.mp4'}
        />
      </div> */}
    </div>
  );
};
